// hero.js
import React from "react";
import { Button } from "react-bootstrap";
import Background from '../../Assets/background.jpg';
import Logo from '../../Assets/Originals/lisa.jpg';
import "./Hero.css";

const MAKASA_URL = process.env.REACT_APP_MAKASA_URL || "http://makasaprogram.bisubilar.org/";


const Hero = ({ onExploreNow = () => {} }) => {
  return (
    <section className="hero">
      {/* Background image + overlays */}
      <div
        className="hero__bg"
        aria-hidden="true"
        style={{ backgroundImage: `url(${Background})` }}
      />

      {/* Decorative blobs for iOS “material depth” */}
      <div className="hero__blob hero__blob--a" aria-hidden="true" />
      <div className="hero__blob hero__blob--b" aria-hidden="true" />

      <div className="hero__inner">
        {/* Left glass panel */}
        <div className="hero__panel hero__panel--left">
          <h1 className="hero__title">Welcome to L.I.S.A.</h1>

          <p className="hero__subtitle">
            LISA, the Local Irrigator System Assessment, is a specialized module
            of{" "}
            <a
              className="hero__link"
              href={MAKASA_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>MAKASA Program</strong>
            </a>
            , designed to enhance AI-driven irrigation decision-making.
          </p>

          {/* CHANGED: from href="/explore" to onClick */}
          <Button className="hero__cta" size="lg" onClick={onExploreNow}>
            Explore Now
          </Button>
        </div>

        {/* Right glass panel with logo */}
        <div className="hero__panel hero__panel--right">
          <div className="hero__logoWrap">
            <img src={Logo} alt="LISA Logo" className="hero__logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
